module.exports = __webpack_public_path__ + "static/assets/c8352ab39132f284174a3cc48eba1eb4.svg";